'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  onSuccess: function onSuccess(request, response) {
    response.parsedBody = function () {
      var contentType = response.headers.get('Content-Type') || '';
      if (contentType.match(/application\/json/)) {
        return response.json();
      }
      return response.text();
    };
    return response;
  },
  onFail: function onFail(request, response) {
    response.parsedBody = function () {
      var contentType = response.headers.get('Content-Type') || '';
      if (contentType.match(/application\/json/)) {
        return response.json();
      }
      return response.text();
    };
    return response;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@synapsestudios/fetch-client/lib/plugins/json.js
// module id = 699
// module chunks = 0